// extracted by mini-css-extract-plugin
export default {"tabBar":"MainLayout_tabBar__PIzjK","sideBar":"MainLayout_sideBar__zH7M3","headerMenu":"MainLayout_headerMenu__ztLNt"};